import Spinner from '@components/_elements/Spinner/Spinner';
import { Typography } from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import MultiColPointDataTable from '@src/components/_shared/MultiColPointDataTable';
import FormattedAlias from '@src/components/_shared/Translations/FormattedAlias';
import useDeviceWidgetConfig from '@src/hooks/devices/useDeviceWidgetConfig';
import { DeviceDetailProps } from '@src/types/devices/DeviceRow.types';
import { WidgetTypePointList } from '@src/types/Widget';

const DeviceDetail: React.FC<DeviceDetailProps> = ({
  deviceId,
  widgetInternalId,
  unitControllerId,
  unitControllerEngineeringId,
  errorMessageId = 'Error fetching device details.',
  isUnitScope = true,
}) => {
  const {
    data: widgetConfig,
    isLoading,
    isError,
  } = useDeviceWidgetConfig<WidgetTypePointList>({
    internalId: widgetInternalId,
    body: {
      sourceDeviceId: deviceId,
      ...(isUnitScope ? { unitControllerId, unitControllerEngineeringId } : {}),
    },
    queryKeys: [deviceId, unitControllerId],
  });

  if (isLoading) {
    return <Spinner type='content-small' />;
  }

  if (isError) {
    return (
      <Typography textAlign='center' marginTop='50px'>
        <FormattedAlias id={errorMessageId} />
      </Typography>
    );
  }

  return (
    <Grid2 container justifyContent='space-evenly'>
      <MultiColPointDataTable
        dataPointsMatrix={widgetConfig?.dataPoints || []}
      />
    </Grid2>
  );
};

DeviceDetail.displayName = 'DeviceDetail';

export default DeviceDetail;
